import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { formatDate } from 'ngx-bootstrap/chronos';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';
import { PlanoAcao } from '../../models/plano-acao.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProjetoPermission } from '../../models/projeto-permission.model';
import { NavigationService } from '../../services/navigation.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { PontoCriticoAcaoService } from '../../services/ponto-critico-acao.service';

@Component({
  selector: 'app-pontos-criticos-acao-edit',
  templateUrl: './pontos-criticos-acao-edit.component.html',
  styleUrls: ['./pontos-criticos-acao-edit.component.scss']
})
export class PontosCriticosAcaoEditComponent extends BaseFormComponent<PlanoAcao> implements OnInit {

  idProjeto: number;
  idEntrega: number;
  idPontoCriticoEntrega: number;
  idIndicador: number;
  idPontoCriticoIndicador: number;
  idPgIndicador: number;
  idPontoCriticoPgIndicador: number;
  idPontoCriticoProjeto: number;

  infoProjeto: ProjetoCadastro;
  actionLabel: string = 'Nova';
  list: any;
  listUsuario: any[];
  audit: AtualizacoesAudit;
  permissions: ProjetoPermission

  constructor(
    private pcAcaoService: PontoCriticoAcaoService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.listUsuario = this.activatedRoute.snapshot.data['listUsuario'];
      this.list = this.activatedRoute.snapshot.data['list'];

      if (this.activatedRoute.snapshot.params.idPontoCritico) {
        this.idPontoCriticoProjeto = this.activatedRoute.snapshot.params.idPontoCritico;
      } else if (this.activatedRoute.snapshot.params.idPontoCriticoEntrega) {
        this.idPontoCriticoEntrega = this.activatedRoute.snapshot.params.idPontoCriticoEntrega;
        if (this.activatedRoute.snapshot.params.idEntrega) { // acessado a partir da aba de entregas
          this.idEntrega = this.activatedRoute.snapshot.params.idEntrega;
        }
      } else if (this.activatedRoute.snapshot.params.idPontoCriticoIndicador) {
        this.idPontoCriticoIndicador = this.activatedRoute.snapshot.params.idPontoCriticoIndicador;
        if (this.activatedRoute.snapshot.params.idIndicador) { // acessado a partir da aba de indicador
          this.idIndicador = this.activatedRoute.snapshot.params.idIndicador;
        }
      } else if (this.activatedRoute.snapshot.params.idPontoCriticoPgIndicador) {
        this.idPontoCriticoPgIndicador = this.activatedRoute.snapshot.params.idPontoCriticoPgIndicador;
        this.idPgIndicador = this.activatedRoute.snapshot.params.idPgIndicador;
      }

      this.initForm();
      this.loaded();
    });
    
  }

  validaIds() {
    // Valida se a ação do idAcao na url da rota pertence ao idProjeto da rota
    if (!this.idPontoCriticoPgIndicador && this.entity.pf_id != this.idProjeto) { // projeto, agregador não possui idProjeto na rota
      this.voltar();
    }
    // valida se o id do ponto critico na url da rota pertence ao id do ponto critico da ação
    if (this.idPontoCriticoProjeto) {
      this.validaId(this.entity.critical_id, this.idPontoCriticoProjeto);
    } else if (this.idPontoCriticoEntrega) {
      this.validaId(this.entity.prt_issue_critical_id, this.idPontoCriticoEntrega);
    } else if (this.idPontoCriticoIndicador) {
      this.validaId(this.entity.ind_critical_id, this.idPontoCriticoIndicador);
    } else if (this.idPontoCriticoPgIndicador) {
      this.validaId(this.entity.ind_critical_id, this.idPontoCriticoPgIndicador);
    }
  }

  validaId(id1: any, id2: any) {
    if (id1 != id2) {
      this.voltar();
    }
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl('', [Validators.required]),
      dt_start: new FormControl(null, [Validators.required]),
      deadline: new FormControl(null, [Validators.required]),
      manager: new FormControl(null, [Validators.required]),
      adjunct: new FormControl(null),
      prt_issue_action_stat_id: new FormControl(null, this.idPontoCriticoEntrega || this.entity?.prt_issue_critical_id  ? [Validators.required] : []),
      ind_action_stat: new FormControl(null, this.idPontoCriticoIndicador || this.idPontoCriticoPgIndicador || this.entity?.ind_critical_id  ? [Validators.required] : []),
      action_stat_id: new FormControl(null, this.idPontoCriticoProjeto || this.entity?.critical_id ? [Validators.required] : []),
    });

    if (this.entity) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.entity);
      this.validaIds();

      if (this.idPontoCriticoProjeto || this.entity?.critical_id) {
        this.audit = {
          action_id: this.entity.id // entity de um PlanoAcao (PfAction) de um Ponto Crítico (PfCritical) vinculado diretamente ao projeto
        };
      } else if (this.idPontoCriticoEntrega || this.entity?.prt_issue_critical_id) {
        this.audit = {
          prt_issue_action_id: this.entity.id // entity de um PlanoAcao (PfPrtIssueAction) de um Ponto Crítico (PfPrtIssueCritical) vinculado diretamente a entrega
        };
      } else if (this.idPontoCriticoIndicador) {
        this.audit = {
          ind_action_id: this.entity.id // entity de um PlanoAcao (PfIndAction) de um Ponto Crítico (PfIndCritical) vinculado diretamente a indicador
        };
      } else if (this.idPontoCriticoPgIndicador) {
        this.audit = {
          pg_ind_action_id: this.entity.id // entity de um PlanoAcao (PfIndAction) de um Ponto Crítico (PfIndCritical) vinculado diretamente a indicador
        };
      }
    }
  }

  typeStatusForm(): string {
    if (this.idPontoCriticoIndicador || this.idPontoCriticoPgIndicador || this.entity?.ind_critical_id) {
      return 'ind_action_stat';
    } else if (this.idPontoCriticoEntrega || this.entity?.prt_issue_critical_id) {
      return 'prt_issue_action_stat_id'; // Campo Situacao contém uma fk para prt_issue_action_stat quando a entity é uma action de entrega (PfPrtIssueAction)
    } else {
      return 'action_stat_id'; // Campo Situacao contém uma fk para action_stat quando a entity é uma action (PfAction)
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir() {
    this.loading();
    if (this.idPontoCriticoProjeto) {
      this.pcAcaoService.delete(this.entity.id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.voltar();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else if (this.idPontoCriticoIndicador) {
      this.pcAcaoService.indicadorDelete(this.entity.id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.voltar();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else if (this.idPontoCriticoEntrega) {
      this.pcAcaoService.entregaDelete(this.entity.id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.voltar();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    } else if (this.idPontoCriticoPgIndicador) {
      this.pcAcaoService.agregadorIndicadorDelete(this.entity.id).subscribe({
        next: (res) => {
          this.loaded();
          this.confirmation().subscribe(() => {
            this.voltar();
          });
        },
        error: (error) => {
          this.msgError(error.error?.message);
          this.loaded();
        }
      });
    }
  }

  voltar() {
    this.navigation.back();
  }

  getDataCreate(): PlanoAcao {
    let data: PlanoAcao;
    data = Object.assign({}, data, this.form.value);

    let formatoDataRegex = /^\d{2}\/\d{2}\/\d{4}$/;
    if (!formatoDataRegex.test(data.dt_start)) {
      data.dt_start = formatDate(data.dt_start, 'DD/MM/YYYY');
    }
    if (!formatoDataRegex.test(data.deadline)) {
      data.deadline = formatDate(data.deadline, 'DD/MM/YYYY');
    }

    if (this.idPontoCriticoIndicador || this.idPontoCriticoPgIndicador) {
      data.ind_critical_id = this.idPontoCriticoIndicador ? this.idPontoCriticoIndicador : this.idPontoCriticoPgIndicador;
    } else if (this.idPontoCriticoEntrega) {
      data.prt_issue_critical_id = this.idPontoCriticoEntrega;
    } else {
      data.critical_id = this.idPontoCriticoProjeto;
    }
    return data;
  }

  salvar(): void {
    if (this.form.valid && this.dataFormValid('dt_start', 'deadline')) {
      this.loading();

      if (this.entity?.id) {
        if (this.idPontoCriticoProjeto) {
          this.addSub(
            this.pcAcaoService.update(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Ação alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoEntrega) {
          this.addSub(
            this.pcAcaoService.entregaUpdate(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Ação alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoIndicador) {
          this.addSub(
            this.pcAcaoService.indicadorUpdate(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Ação alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoPgIndicador) {
          this.addSub(
            this.pcAcaoService.agregadorIndicadorUpdate(this.getDataCreate(), this.entity?.id).subscribe({
              next: (res) => {
                this.msgSuccess('Ação alterada com sucesso!');
                EventSharedService.get('auditRefresh').emit();
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      } else {
        if (this.idPontoCriticoProjeto) {
          this.addSub(
            this.pcAcaoService.create(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'pontos-criticos', this.idPontoCriticoProjeto, 'plano-acao', res.id]);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoEntrega) {
          this.addSub(
            this.pcAcaoService.entregaCreate(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  if (this.idEntrega) { // navegação a partir da aba de entregas
                    this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'entregas', this.idEntrega, 'ponto-critico', this.idPontoCriticoEntrega, 'plano-acao', res.id]);
                  } else { // navegação a partir da aba de pontos criticos
                    this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'entrega', this.idPontoCriticoEntrega, 'plano-acao', res.id]);
                  }
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoIndicador) {
          this.addSub(
            this.pcAcaoService.indicadorCreate(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  if (this.idIndicador) { // navegação a partir da aba de indicadores
                    this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'indicadores', this.idIndicador, 'ponto-critico', this.idPontoCriticoIndicador, 'plano-acao', res.id]);
                  } else { // navegação a partir da aba de pontos criticos
                    this.navigation.replace(['projetos', 'projeto', this.idProjeto, 'pontos-criticos', 'indicador', this.idPontoCriticoIndicador, 'plano-acao', res.id]);
                  }
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        } else if (this.idPontoCriticoPgIndicador) {
          this.addSub(
            this.pcAcaoService.agregadorIndicadorCreate(this.getDataCreate()).subscribe({
              next: (res) => {
                this.confirmation().subscribe(() => {
                  this.router.navigate(['projetos', 'agregador', 'indicadores', this.idPgIndicador, 'ponto-critico', this.idPontoCriticoPgIndicador, 'plano-acao', res.id]);
                })
                this.loaded();
              },
              error: (error) => {
                this.msgError(error?.error?.message);
                this.loaded();
              },
            })
          );
        }
      }
    } else {
      this.markAsDirty();
    }
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }
}
